// src/widgetConfigInit.ts
import { v4 } from 'uuid';
import { getClientInfo } from '../services/authService';
import { sendStatistics } from '../services/dataColectorService';
import {logDebug, logError, logTrace, setLogLevels} from './logger';
import ColorTheme from './ColorThemes.json';
import '../Customization.scss';
import ReactDOM from "react-dom/client";
import {colorKeys}  from "../constants";

export const initializeWidgetConfig = async (contextValueIn:any = null) => {
  sessionStorage.setItem("session_ID", v4().substring(0, 8));
sessionStorage.setItem("message_id", "0");
    const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// const locale_messages = new Map<string, any>(Object.entries(require('../ds/locale.json')));
// Create a style element before React initialization
const bodyStyle = document.createElement('style');
  // Destructure to get rootStyle and contextValue

  document.head.appendChild(bodyStyle);


  const params = new URLSearchParams(window.location.search);
  const serializedWidgetParams = params.get('widget_params');

  let widgetParams = null;
  if (serializedWidgetParams) {
    try {
      widgetParams = JSON.parse(decodeURIComponent(serializedWidgetParams));
    } catch (error) {
      logError('Error deserializing widget parameters:', error);
    }
  } else {
    logDebug('widget_params not found in the URL');
  }

  const floatingWidget_states = [
    { name: 'minimized', duration: 10000 },//10 seconds
    { name: 'branded', duration: 5000 }, //5 seconds
    { name: 'minimized', duration: 1000 },//1 second
    { name: 'teaser', duration: 5000 },//5 seconds
    { name: 'open', duration: 0 }//0 seconds
  ];

  let userId = contextValueIn ? contextValueIn?.userId : params.get("userId") || widgetParams?.userId || "defaultUser",
      user_class = contextValueIn ? contextValueIn?.user_class : params.get("user_class") || widgetParams?.user_class ||  "default",
    client_token = contextValueIn ? contextValueIn?.client_token : params.get("client_token") || widgetParams?.client_token ||  "defaultToken",
    article_index = contextValueIn ? contextValueIn?.article_index : params.get("article_index") || widgetParams?.article_index ||  null,
    proxy = contextValueIn ? contextValueIn?.proxy : params.get("proxy") || widgetParams?.proxy ||   "",
    follow_up_question = contextValueIn ? contextValueIn?.follow_up_question : params.get("follow_up_question") || widgetParams?.follow_up_question ||  null,
    languageForWidget = contextValueIn && contextValueIn.language_for_widget !== undefined ?  contextValueIn.language : params.get("language") || widgetParams?.language ||  null,
    languageForChat = contextValueIn && contextValueIn.language_for_chat !== undefined ? contextValueIn.language_for_chat : params.get("language_for_chat") || widgetParams?.language_for_chat || null,
    floatingState = params.get("floatingState") || widgetParams?.floatingState  || floatingWidget_states,
    asset_type =  contextValueIn ? contextValueIn?.asset_type : params.get("assetType") || widgetParams?.assetType ||  null,
    asset_symbol = contextValueIn ? contextValueIn?.asset_symbol : params.get("assetSymbol") || widgetParams?.assetSymbol ||  null,
    follow_up_questions = params.get("follow_up_questions") || widgetParams?.follow_up_questions || null,
    color_theme = contextValueIn ? contextValueIn?.color_theme : params.get("color_theme") || widgetParams?.color_theme ||  null,
    widgetCustomizationData:any,
    data,
    client_id = "defaultClient",
    error_message = "",
    should_present_legal_banner = false,
    welcome_message,
    widget_type = contextValueIn ? contextValueIn?.widget_type : params.get("widget_type") || widgetParams?.widget_type ||  (follow_up_question ? 'FOLLOWUP-QUESTION_WIDGET' :"STARTER")

  if (!client_token) client_token = "defaultToken";
  if (!userId) userId = "defaultUser";
  languageForWidget = languageForWidget === "NULL" ? null : languageForWidget;

  if (!languageForWidget) data = await getClientInfo(proxy, userId, client_token);

  if (!data) {
    widgetCustomizationData = {};
  } else {

        if (data.status === 311) {
            document.open();
            document.write(data.html);
            document.close();
            setTimeout(() => {
                window.location.href = "about:blank?error=user_was_not_allowed_in_WNSTN_chat";
            }, 3000); // 3 seconds delay
            document.close()
            return {
                welcome_message: null,
                floatingState: null,
                asset_type: undefined,
                follow_up_questions: undefined,
                root: root
            };
        }
    const localhost = window.location.href.includes("localhost")?"TRACE": null;
    setLogLevels(localhost ? localhost : data.log_level || '', { user_id: userId, user_class:user_class, client_id: data.client_name, client_token: client_token, proxy: proxy });
    const log_api_enabled = process.env.REACT_APP_LOG_API_SERVICE_ENABLED;
    const data_collector_api_enabled = process.env.REACT_APP_DATA_COLLECTOR_API_SERVICE_ENABLED;
    if(log_api_enabled === "FALSE")
            logDebug('frontend log service API is disabled')
       if(data_collector_api_enabled === "FALSE")
            logDebug('data collector service API is disabled')
    if(userId === "defaultUser")
        logDebug("params:",params, "widgetParams:",widgetParams, "contextValueIn:",contextValueIn)
    logTrace(widgetParams)
    widgetCustomizationData = data.widget_config;
    if (color_theme) {
        if (Array.isArray(widgetCustomizationData)) {
            const matchedItem = widgetCustomizationData.find(item => item.color_theme === color_theme);
            widgetCustomizationData = matchedItem ? matchedItem : widgetCustomizationData[0];
        }
    }

    client_id = data.client_name;
    error_message = widgetCustomizationData.error_message;
    should_present_legal_banner = contextValueIn?.should_present_legal_banner || data.should_present_legal_banner;
    // const welcome_message_per_client_from_db = widgetCustomizationData.welcome_message || null;
    const languageKey = languageForChat || "EN";
    // const welcomeMessage = data. welcome_message_per_client_from_db || locale_messages.get(languageKey)?.welcome_message;
    welcome_message = data.welcome_message.is_new_user_for_welcome ? data.welcome_message.language[languageKey]: null;
    if (!client_id) client_id = "defaultClient";
  }

  if (follow_up_question && article_index)
    sendStatistics(proxy, client_id, userId, client_token, { 'ARTICLE_WIDGET_ACTIVATION': 1, 'article_index': article_index }, false);
  else if (follow_up_question)
    sendStatistics(proxy, client_id, userId, client_token, { 'ASSET_WIDGET_ACTIVATION': 1 }, false);

  let lclObj: any = null;
  if(!color_theme)
        widgetCustomizationData.color_theme = languageForChat && !widgetCustomizationData.color_theme ? "lightTheme" :  widgetCustomizationData.color_theme
   // else

  sessionStorage.setItem('userTheme', widgetCustomizationData.color_theme);
  switch (widgetCustomizationData.color_theme) {
    case 'lightTheme':
      lclObj = ColorTheme['lightTheme'];
      break;
    case 'darkTheme':
      lclObj = ColorTheme['darkTheme'];
      break;
    default:
      lclObj = ColorTheme['lightTheme'];
      break;
  }

for (const [, key] of colorKeys) {
  if (!widgetCustomizationData[key]) {
    widgetCustomizationData[key] = "default";
  }
}

if (!widgetCustomizationData.sidebar_position_flag)
  widgetCustomizationData.sidebar_position_flag = "default"
if (!widgetCustomizationData.logo_url || widgetCustomizationData.logo_url === "default")
    widgetCustomizationData.logo_url = "none"
if (!widgetCustomizationData.badge_url)
  widgetCustomizationData.badge_url = "default"

 if(widgetCustomizationData.color_theme === "defaultTheme"){
    document.body.classList.add("defaultTheme");
  }


bodyStyle.textContent = `
  :root {
    ${colorKeys.map(([cssVar, key]) => {
      return `${cssVar}: ${
        widgetCustomizationData[key] && widgetCustomizationData[key] !== "default"
          ? widgetCustomizationData[key]
          : lclObj[key]
      };`;
    }).join('\n    ')}
  }
`;


widgetCustomizationData.reset_all_styles = false
if (!widgetCustomizationData.reset_all_styles) {
  if (widgetCustomizationData.sidebar_position_flag === "right") {
    document.body.classList.add("sidebarpositionflag")
  }

widgetCustomizationData.ticker_flag = "FALSE";
  if (widgetCustomizationData.ticker_flag) {
    document.body.classList.add("hideTicker")
  }

}

  const contextValueOut = {
  userId: userId||"defaultUser",
  userClass: user_class||"default",
  logourl: widgetCustomizationData ? widgetCustomizationData.logo_url : "none",
  badgeurl: widgetCustomizationData ? widgetCustomizationData.badge_url : "none",
  error_message: error_message,
  should_present_legal_banner: should_present_legal_banner,
  client_id: client_id,
  client_token: client_token,
  article_index: article_index,
  follow_up_question: follow_up_question,
  proxy: proxy,
  welcome_message: welcome_message,
  language_for_widget: languageForWidget,
  floatingState:floatingState,
  asset_type: asset_type,
  asset_symbol: asset_symbol,
  follow_up_questions:follow_up_questions,
  language_for_chat:languageForChat,
  widget_type: widget_type,
  prompt_type: null,
  root: root
  };

  return {contextValueOut }
};